import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { TextStyleFieldModel } from '../../../../Common/PageBuilder/models/text-style-field.model';
import { MentionCustomizationFieldModel } from '../../../Shared/models/mention-customization-field.model';
import { GenericStyleModel } from '../../../../Common/Styles/models/generic-style.model';
import { StyleTypesApiEnum } from '../../../../api/styles/enum/style-types-api.enum';
import { TextStyleDefaultsModel } from '../../../../Common/PageBuilder/models/text-style-defaults.model';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { ImageStyleFieldModel } from '../../../../Common/PageBuilder/models/image-style-field.model';
import { ImageStyleFieldComponent } from '../../../../Common/PageBuilder/components/FormFields/ImageStyleField/image-style-field.component';
import { BriefingStyleStateEnum } from '../../../../Common/MonitorShared/enum/briefing-style-state.enum';
import { BriefingDateStyleFieldModel } from '../../../Briefings/models/briefing-date-style-field.model';
import { AlertsService } from '../../services/alerts.service';
import { AlertModel } from '../../models/alert.model';
import { briefingsStyleDropdownOptions } from '../../../../Monitor/Briefings/models/briefings-style-dropdown-options.model';
import { AlertBlockTypeEnum } from '../../enums/alert-block-type.enum';
import { alertBlockTypeToGeneralStylesPropertyMap } from '../../models/alert-global-styles-property.const';
import { MonitoringTitleFieldModel } from '../../../Shared/models/monitoring-title-field.model';

@Component({
    selector: 'agpr-alert-global-customization',
    templateUrl: './alert-global-customization.component.html',
    styleUrls: ['./alert-global-customization.component.scss'],
    standalone: false
})
export class AlertGlobalCustomizationComponent implements OnInit, OnDestroy {
    @Input() public id: string;

    currentAlert: AlertModel = new AlertModel();
    subscriptions: Subscription[] = [];

    alertBlockTypeEnum = AlertBlockTypeEnum;

    imageField: TextStyleFieldModel;
    titleField: MonitoringTitleFieldModel;
    sectionHeadingField: TextStyleFieldModel;
    textField: TextStyleFieldModel;
    headingField: TextStyleFieldModel;
    dateStyleField: BriefingDateStyleFieldModel;
    tableOfContentField: TextStyleFieldModel;
    mentionStyleField: MentionCustomizationFieldModel;

    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        private alertsService: AlertsService
    ) {}

    ngOnInit() {
        this.subscriptions.push(
            this.alertsService.getCurrentAlert().subscribe(
                currentAlert => {
                    if (currentAlert) {
                        this.currentAlert = currentAlert;
                    }
                }
            )
        );

        this.imageField = new ImageStyleFieldModel(
            'image',
            true,
            new TextStyleDefaultsModel(
                '24px',
                '#5e6473',
                true
            ),
            'Briefing.imageTextStyle.image.label',
            true,
            true,
            true,
            StyleTypesApiEnum.IMAGE,
            ImageStyleFieldComponent,
            '',
            briefingsStyleDropdownOptions,
            null,
            false
        );

        this.titleField = new MonitoringTitleFieldModel(
            'title',
            false,
            new TextStyleDefaultsModel(
                '24px',
                '#5e6473',
                true
            ),
            'Briefing.textStyle.title.label',
            true,
            true,
            true,
            StyleTypesApiEnum.TITLE,
            null,
            null,
            true,
            true,
            briefingsStyleDropdownOptions
        );

        this.textField = new TextStyleFieldModel(
            'title',
            true,
            new TextStyleDefaultsModel(
                '14px',
                '#292929',
                false
            ),
            'Briefing.textStyle.text.label',
            true,
            true,
            true,
            StyleTypesApiEnum.TEXT,
            null,
            null,
            true,
            true,
            briefingsStyleDropdownOptions
        );

        this.dateStyleField = new BriefingDateStyleFieldModel(
            null,
            'date',
            'DateStyleField.dateLine',
            ''
        );

        this.tableOfContentField = new TextStyleFieldModel(
            'tableOfContent',
            true,
            new TextStyleDefaultsModel(
                '14px',
                '#5e6473',
                true
            ),
            'Briefings.blockType.tableOfContent',
            true,
            true,
            true,
            StyleTypesApiEnum.TABLE_OF_CONTENT,
            null,
            null,
            true,
            true,
            briefingsStyleDropdownOptions
        );

        this.mentionStyleField = new MentionCustomizationFieldModel(
            null,
            'mention',
            'MentionStyleField.heading',
            ''
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    /**
     * Handles changes to date style
     */
    styleChange(styleModel: GenericStyleModel, blockType: AlertBlockTypeEnum): void {
        const alertGeneralStylesProperty = alertBlockTypeToGeneralStylesPropertyMap.get(blockType);

        if (!styleModel.isSavedStyle() && (styleModel as any).displayStyleState !== BriefingStyleStateEnum.CUSTOM) {
            const defaultStyle = this.alertsService.getDefaultStyle(blockType, styleModel.styleState as BriefingStyleStateEnum);
            defaultStyle.template = null;
            this.currentAlert.generalStyles.setProperty(alertGeneralStylesProperty, defaultStyle.clone());
            this.alertsService.generalStylesBlockUpdated(blockType, defaultStyle);

            return;
        }

        this.currentAlert.generalStyles.setProperty(alertGeneralStylesProperty, styleModel.clone());
        this.alertsService.generalStylesBlockUpdated(blockType, styleModel);
    }
}
